type FitArgs = {
  widths: number[]
  moreWidth: number
  pinned: boolean[]
  gap: number
  limit: number
}

export const fitToWidth = ({
  widths,
  moreWidth,
  pinned,
  gap,
  limit
}: FitArgs): boolean[] => {
  const overflowed = widths.map(() => false)

  const rowWidth = () => {
    const visible = widths.filter((_, index) => !overflowed[index])
    const hasMore = overflowed.some(Boolean)
    const items = visible.length + (hasMore ? 1 : 0)

    return (
      visible.reduce((sum, width) => sum + width, 0) +
      (hasMore ? moreWidth : 0) +
      gap * Math.max(0, items - 1)
    )
  }

  const untouchedWidth = rowWidth()

  for (let index = widths.length - 1; index >= 0; index -= 1) {
    if (rowWidth() <= limit) {
      break
    }

    if (pinned[index]) {
      continue
    }

    overflowed[index] = true
  }

  if (overflowed.some(Boolean) && rowWidth() >= untouchedWidth) {
    return widths.map(() => false)
  }

  return overflowed
}
